import type { DeliveryMethodKind } from "@dransay/api/models";
import type { FiltersState } from "../filters/types";
import { filterSchemaParser } from "../filters/utils";

export function buildPdlExclusiveProductsFetchUrl(
	vendorId: string | undefined,
	deliveryMethodKind: DeliveryMethodKind | undefined,
	filters: FiltersState,
): string {
	const params = new URLSearchParams({ type: "exclusive" });
	if (vendorId) {
		params.set("vendorId", vendorId);
	}
	if (deliveryMethodKind) {
		params.set("deliveryMethod", deliveryMethodKind);
	}
	const serializedFilters = filterSchemaParser.serialize(filters);
	if (serializedFilters && serializedFilters !== "{}") {
		params.set("filters", serializedFilters);
	}
	return `/api/curated-products?${params.toString()}`;
}
